import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
const WHATSAPP_NUMBER = "918308832896";
const WHATSAPP_MESSAGE = encodeURIComponent("Hi! I'm interested in renting a Meta Quest 3. Can you share more details?");

const WhatsAppButton = () => {
  return (
    <motion.a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-xl transition-shadow"
      aria-label="Chat on WhatsApp"
    >
    <FaWhatsapp className="w-7 h-7 text-white" />
    </motion.a>
  );
};

export default WhatsAppButton;
